import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {ANALYSIS_TOOL_SPACING} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisMainViewItemType, MainViewComponentProps} from 'analysis-tool/ui/main-view/MainViewTypes';
import {assert} from 'Asserts';
import PersistedDataFrameTableWrapper from 'data-frames/wrapper/PersistedDataFrameTableWrapper';
import {ActionOrigin, PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

type ExportDataCatalogDatasetOutputViewProps =
  MainViewComponentProps<AnalysisMainViewItemType.EXPORT_DATA_CATALOG_DATASET_OUTPUT>;

export default function ExportDataCatalogDatasetOutputView({
  selectedItem,
  step,
  clientStateId,
}: ExportDataCatalogDatasetOutputViewProps): JSX.Element {
  function getContents(): ReactNode {
    switch (step.statusCode) {
      case PipelineStepStatusCode.FAILED:
        assert(step.statusMessage != null, 'Expected statusMessage to be defined for FAILED step.');
        return <>{step.statusMessage}</>;
      case PipelineStepStatusCode.SUCCEEDED:
        return (
          <PersistedDataFrameTableWrapper
            actionOrigin={ActionOrigin.ANALYSIS_TOOL}
            clientStateId={clientStateId}
            dataFrameId={selectedItem.dataFrameId}
            includeOpenDatasetOption={true}
          />
        );
      default:
        throw new Error(`Unexpected step status for EXPORT_DATA_CATALOG_DATASET: ${step.statusCode}`);
    }
  }

  return (
    <div
      className={css(styles.container)}
      {...getTestProps({component: 'ExportDataCatalogDatasetOutputView', element: 'root'})}
    >
      {getContents()}
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    margin: ANALYSIS_TOOL_SPACING,
  },
});
